import { Injectable } from '@angular/core';
import { Service } from 'src/app/core/jsonapi/service';
import { DataImportRow } from '../_types/data-import-row';

@Injectable({ providedIn: 'root' })
export class DataImportRowsService extends Service<DataImportRow> {
    public override type = 'dataImportRows';
    public override url = 'common/dataImportRows';
}
